import React, { FunctionComponent } from "react";
import { IIconProps } from "../icon";

export const EmojiStressed: FunctionComponent<IIconProps> = (props) => {
  const { color, outlined, ...rest } = props;
  return (
    <svg viewBox="0 0 52 52" {...rest}>
      <g
        id="Icons/Body/Emoji-Stressed"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g id="Group" transform="translate(3.000000, 3.000000)" stroke="#222222" strokeWidth="3">
          <circle id="Oval" cx="23" cy="23" r="23"></circle>
          <line x1="12.2728" y1="19.9312889" x2="18.4" y2="13.8061333" id="Path"></line>
          <line x1="18.4" y1="19.9333333" x2="12.2728" y2="13.8040889" id="Path"></line>
          <line x1="27.6" y1="19.9312889" x2="33.7272" y2="13.8061333" id="Path"></line>
          <line x1="33.7272" y1="19.9333333" x2="27.6" y2="13.8040889" id="Path"></line>
          <rect id="Rectangle" x="19.9333333" y="29.1333333" width="6.13333333" height="9.2" rx="3.06666667"></rect>
          <circle id="Oval" cx="23" cy="23" r="23"></circle>
          <line x1="12.2728" y1="19.9312889" x2="18.4" y2="13.8061333" id="Path"></line>
          <line x1="18.4" y1="19.9333333" x2="12.2728" y2="13.8040889" id="Path"></line>
          <line x1="27.6" y1="19.9312889" x2="33.7272" y2="13.8061333" id="Path"></line>
          <line x1="33.7272" y1="19.9333333" x2="27.6" y2="13.8040889" id="Path"></line>
          <rect id="Rectangle" x="19.9333333" y="29.1333333" width="6.13333333" height="9.2" rx="3.06666667"></rect>
        </g>
      </g>
    </svg>
  );
};
